var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 25H20.8333H87.5",
    stroke: "#0F172A",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1668 24.9999V83.3332C79.1668 85.5434 78.2889 87.663 76.726 89.2258C75.1632 90.7886 73.0436 91.6666 70.8335 91.6666H29.1668C26.9567 91.6666 24.8371 90.7886 23.2743 89.2258C21.7115 87.663 20.8335 85.5434 20.8335 83.3332V24.9999M33.3335 24.9999V16.6666C33.3335 14.4564 34.2115 12.3368 35.7743 10.774C37.3371 9.21123 39.4567 8.33325 41.6668 8.33325H58.3335C60.5436 8.33325 62.6632 9.21123 64.226 10.774C65.7889 12.3368 66.6668 14.4564 66.6668 16.6666V24.9999",
    stroke: "#0F172A",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6665 45.8333V70.8333",
    stroke: "#0F172A",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3335 45.8333V70.8333",
    stroke: "#0F172A",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDel);
export default __webpack_public_path__ + "static/media/del.c39a5c1517024f5bbca2d1b30c29e4e7.svg";
export { ForwardRef as ReactComponent };